var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zv-block zv-blank"},[_c('div',{staticClass:"zv-blank-wrapper"},[_c('em',{staticClass:"zv-blank-logo"}),_c('span',[_vm._v(_vm._s(_vm.emptyInfo))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }